import { postAPI } from "../services/ApiService";

export const validateToken = async() => {
    let res = await postAPI('/auth/check-token/')
    return res;
}